import { AfterViewInit, ElementRef, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
var RecoveryCodeStepComponent = /** @class */ (function () {
    function RecoveryCodeStepComponent() {
        this.insertRecoveryCode = new EventEmitter();
        this.toSoftwareTokenStep = new EventEmitter();
    }
    RecoveryCodeStepComponent.prototype.ngAfterViewInit = function () {
        this.recoveryCodeInputElement.nativeElement.focus();
    };
    return RecoveryCodeStepComponent;
}());
export { RecoveryCodeStepComponent };
